export const chase = true;
export const clouds = false;
export const zoomed = false;
export const cars = true;
export const night = false;
export const map = {
  rows: 25,
  coins: 3
}